export { default } from './useTheme';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/styles/esm/useTheme/index.js
// module id = 326
// module chunks = 121